
import ProgressIndicatorPlugin from "../core/ProgressIndicatorPlugin";

export default class TestProgressIndicatorPlugin extends ProgressIndicatorPlugin {
    get minHeight() {
        return 20;
    }

    get minHeightHover() {
        return 50;
    }

    drawForeground(context, width, height, isHover) {
        context.fillStyle = "rgba(230, 230, 230)";
        context.font = `12px Arial`;
        context.textAlign = "left";
        context.fillText("foreground text", 100, height / 2 + 5);
    }

    drawBackground(context, width, height, isHover) {
        context.fillStyle = "rgba(230, 230, 230)";
        context.font = `12px Arial`;
        context.textAlign = "right";
        context.fillText("background text", width - 2, height / 2 + 5);
    }
}

